<h1 mat-dialog-title>User Preferences</h1>
<div mat-dialog-content>
  <!-- ── Display preferences ─────────────────────────────────── -->
  <mat-checkbox [checked]="useFlatTagTableView" (change)="onFlatTagTableToggle($event.checked)">
    {{ userPreferenceLabel[userPreference.USE_FLAT_TAG_TABLE_VIEW] }}
  </mat-checkbox>

  <mat-divider style="margin: 1rem 0;"></mat-divider>

  <!-- ── Calendar invite consent ─────────────────────────────── -->
  <div class="consent-section">
    <div class="consent-row">
      <div class="consent-label">
        <span class="consent-title">Consent to calendar invites</span>
        <span class="consent-description">
          Allow this application to send calendar invites to your Outlook calendar via Microsoft Graph when you are added to a punch round.
        </span>
      </div>
      <div class="consent-toggle-area">
        @if (calendarConsentGranted === null) {
          <span class="consent-status not-set">Not set</span>
        } @else if (calendarConsentGranted) {
          <span class="consent-status granted">Granted</span>
          <button mat-stroked-button color="warn" (click)="onConsentToggleRequest(false)">Revoke</button>
        } @else {
          <span class="consent-status declined">Declined</span>
          <button mat-stroked-button color="primary" (click)="onConsentToggleRequest(true)">Grant</button>
        }
      </div>
    </div>

    <!-- Warning panel shown before applying a consent change -->
    @if (showConsentWarning) {
      <div class="consent-warning-panel">
        <mat-icon color="warn">warning</mat-icon>
        @if (pendingConsentValue) {
          <p>
            You are about to <strong>grant</strong> consent to calendar invites.
            The application will be able to add calendar events directly to your Outlook calendar.
          </p>
        } @else {
          <p>
            You are about to <strong>revoke</strong> consent to calendar invites.
            You will <strong>no longer receive calendar events</strong> for punch rounds in your Outlook calendar.
            You will still receive email notifications.
          </p>
        }
        <div class="consent-warning-actions">
          <button mat-button (click)="dismissConsentWarning()">Cancel</button>
          <button mat-raised-button [color]="pendingConsentValue ? 'primary' : 'warn'" (click)="confirmConsentChange()">
            {{ pendingConsentValue ? 'Grant Consent' : 'Revoke Consent' }}
          </button>
        </div>
      </div>
    }
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onClose()">Close</button>
</div>
